<template>
    <svg v-if="!props.showDescriptions" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#464646" fill-opacity="0.5" :class="{'info-btn__circle':showDescriptions}" />
        <path
            d="M25.1992 19.6C25.1992 18.06 26.4592 16.8 27.9992 16.8C29.5392 16.8 30.7992 18.06 30.7992 19.6C30.7992 21.14 29.5392 22.4 27.9992 22.4C26.4592 22.4 
                25.1992 21.14 25.1992 19.6Z"
            fill="white"
            :class="{'info-btn__path':showDescriptions}"
        />
        <path
            d="M26.1328 27.44C26.1328 26.7183 26.9685 26.1333 27.9995 26.1333C29.0304 26.1333 29.8661 26.7183 29.8661 27.44V37.8933C29.8661 38.615 29.0304 39.2 27.9995 
                39.2C26.9685 39.2 26.1328 38.615 26.1328 37.8933V27.44Z"
            fill="white"
            :class="{'info-btn__path':showDescriptions}"
        />
    </svg>
    <svg v-else width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="28" fill="#464646" fill-opacity="0.5" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.3996 28.0001C50.3996 40.3713 40.3708 50.4001 27.9996 50.4001C15.6284 50.4001 5.59961 40.3713 5.59961 28.0001C5.59961 15.6289 15.6284 5.6001 
                27.9996 5.6001C40.3708 5.6001 50.3996 15.6289 50.3996 28.0001ZM25.1996 19.6001C25.1996 18.0601 26.4596 16.8001 27.9996 16.8001C29.5396 16.8001 
                30.7996 18.0601 30.7996 19.6001C30.7996 21.1401 29.5396 22.4001 27.9996 22.4001C26.4596 22.4001 25.1996 21.1401 25.1996 19.6001ZM27.9996 26.1334C26.9687 
                26.1334 26.1329 26.7184 26.1329 27.4401V37.8934C26.1329 38.6151 26.9687 39.2001 27.9996 39.2001C29.0305 39.2001 29.8663 38.6151 29.8663 
                37.8934V27.4401C29.8663 26.7184 29.0305 26.1334 27.9996 26.1334Z"
            fill="white"
        />
    </svg>
</template>

<script setup lang="ts">
    const props = defineProps({
        showDescriptions: {
            type: Boolean,
            required: true
        }
    });
</script>
